(function(){
  var CSS =
  '#tyo-bnav{display:none}'+
  '@media(max-width:767px){'+
  '#tyo-bnav{display:flex;align-items:flex-end;position:fixed;left:0;right:0;bottom:0;z-index:9998;background:#fff;border-top:1px solid #EEE3D4;box-shadow:0 -2px 14px rgba(0,0,0,.06);padding:6px 0 calc(6px + env(safe-area-inset-bottom));font-family:"DM Sans",-apple-system,sans-serif}'+
  '#tyo-bnav a{flex:1;display:flex;flex-direction:column;align-items:center;gap:3px;text-decoration:none;color:#7A6E62;font-size:10px;font-weight:600;letter-spacing:.2px}'+
  '#tyo-bnav a svg{width:22px;height:22px;stroke:currentColor;fill:none;stroke-width:1.7}'+
  '#tyo-bnav a.tyo-bnav-active{color:#C51985}'+
  '#tyo-bnav .tyo-bnav-badge{position:relative}'+
  '#tyo-bnav .tyo-bnav-badge b{position:absolute;top:-4px;right:-8px;min-width:15px;height:15px;padding:0 3px;background:#C51985;color:#fff;border-radius:99px;font-size:9px;line-height:15px;text-align:center;font-weight:700}'+
  /* raised pink circle — Build Your Set */
  '#tyo-bnav a.tyo-bnav-cta{color:#E921AD;font-weight:700;gap:4px}'+
  '#tyo-bnav .tyo-bnav-fab{width:48px;height:48px;border-radius:50%;background:#E921AD;border:3px solid #fff;margin-top:-22px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(233,33,173,.40)}'+
  '#tyo-bnav .tyo-bnav-fab svg{width:23px;height:23px;fill:#fff;stroke:none}'+
  'body{padding-bottom:70px !important}'+
  '[class*="whatsapp" i],[id*="whatsapp" i],[class*="superlemon" i],[id*="superlemon" i],[class*="wa-widget" i],[class*="wa-chat" i],[class*="floating-whatsapp" i],[class*="chat-widget" i],[class*="wa-btn" i],[id*="wa-widget" i]{bottom:84px !important}'+
  '}';
  function icon(name){
    var p={
      home:'<path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V21h14V9.5"/>',
      cat:'<rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/>',
      cart:'<circle cx="9" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/><path d="M2 3h3l2.2 12.5h11L21 7H6.2"/>',
      user:'<circle cx="12" cy="8" r="3.6"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/>',
      spark:'<path d="M12 3.2 13.9 8.6 19.3 10.5 13.9 12.4 12 17.8 10.1 12.4 4.7 10.5 10.1 8.6z"/><path d="M17.9 15.1l.75 2.05 2.05.75-2.05.75-.75 2.05-.75-2.05-2.05-.75 2.05-.75z"/>'
    };
    return '<svg viewBox="0 0 24 24" aria-hidden="true">'+p[name]+'</svg>';
  }
  function build(){
    if(document.getElementById('tyo-bnav')) return;
    var s=document.createElement('style'); s.textContent=CSS; document.head.appendChild(s);
    var path=location.pathname;
    function act(match){ return match.test(path)?' tyo-bnav-active':''; }
    var nav=document.createElement('nav'); nav.id='tyo-bnav'; nav.setAttribute('aria-label','Mobile');
    nav.innerHTML=
      '<a href="/" class="'+(path==='/'?'tyo-bnav-active':'')+'">'+icon('home')+'<span>Home</span></a>'+
      '<a href="/collections" class="'+(/^\/collections/.test(path)?'tyo-bnav-active':'')+'">'+icon('cat')+'<span>Categories</span></a>'+
      '<a href="/pages/build-your-set" class="tyo-bnav-cta'+act(/build-your-set/)+'" aria-label="Build your own set">'+
        '<span class="tyo-bnav-fab">'+icon('spark')+'</span><span>Build Set</span></a>'+
      '<a href="/cart" class="tyo-bnav-badge'+act(/^\/cart/)+'">'+icon('cart')+'<b id="tyo-bnav-count" hidden>0</b><span>Cart</span></a>'+
      '<a href="/account" class="'+act(/account/)+'">'+icon('user')+'<span>Profile</span></a>';
    document.body.appendChild(nav);
    refreshCount();
  }
  function refreshCount(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      var b=document.getElementById('tyo-bnav-count'); if(!b)return;
      if(c && c.item_count>0){ b.textContent=c.item_count; b.hidden=false; } else { b.hidden=true; }
    }).catch(function(){});
  }
  var of=window.fetch;
  if(of){ window.fetch=function(){var a=arguments;return of.apply(this,a).then(function(res){try{var u=(a[0]&&a[0].url)||a[0]||'';if(typeof u==='string'&&/\/cart\/(add|change|update|clear)/.test(u))setTimeout(refreshCount,300);}catch(e){}return res;});}; }
  if(document.readyState!=='loading') build(); else document.addEventListener('DOMContentLoaded',build);
})();
